module.exports = __webpack_public_path__ + "img/lit_daily.4e68eb50.png";